'use client';

import { createContext, type ReactNode, useContext } from 'react';

const HotPadsAppContext = createContext(false);

export function HotPadsAppProvider({ isHotPadsApp, children }: { isHotPadsApp: boolean; children: ReactNode }) {
  return <HotPadsAppContext.Provider value={isHotPadsApp}>{children}</HotPadsAppContext.Provider>;
}

export function useIsHotPadsApp(): boolean {
  return useContext(HotPadsAppContext);
}
